import store from '@/store/'
import isArray from 'lodash/isArray'
// eslint-disable-next-line no-unused-vars
export default function hasPublisher({ from, next, router, to }) {
  const publishers = store.getters['user/publishers'] || []
  const userType = store.getters['user/type']

  // redirect to dashboard if unauthorized
  if (isArray(publishers) && publishers?.length === 0 && !['project-manager', 'graphic-designer', 'agency', 'admin'].includes(userType)) {
    return router.push({ name: 'dashboard' })
  }

  // OR do nothing and go next
  return next()
}
